function __$styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

import { createElement, Fragment, Component } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
/*
 * Walk a component tree and recursively render it.
 */


var ReactFromJSON =
/** @class */
function (_super) {
  __extends(ReactFromJSON, _super);

  function ReactFromJSON(props) {
    var _this = _super.call(this, props) || this;

    _this.internalMapping = {};
    _this.state = {
      counter: {}
    };

    _this.ComponentLookup = function (_a) {
      var componentIndex = _a.componentIndex,
          componentType = _a.componentType,
          propIndex = _a.propIndex;
      var components = _this.props.components;

      if (!components) {
        throw "Detected `ComponentLookup` prop on a component, but `components` is undefined. You need to define `components` if using `ComponentLookup` props.";
      }

      if (!components[componentType]) {
        throw "Detected `" + componentType + "` ComponentLookup, but it's not defined in your `components` object.";
      }

      var component = components[componentType][componentIndex];
      return _this.renderComponent(_assign({}, component, {
        props: _assign({
          id: component.id || componentIndex,
          propIndex: propIndex
        }, component.props)
      }));
    };

    _this.resolveProp = function (prop, propKey, index) {
      var _a = _this.props.mapProp,
          mapProp = _a === void 0 ? function (p) {
        return p;
      } : _a;
      var mappedProp = mapProp(prop);

      if (mappedProp === null) {
        return mappedProp;
      } else if (Array.isArray(mappedProp)) {
        return mappedProp.map(function (prop, index) {
          return _this.resolveProp(prop, propKey, index);
        });
      } else if (typeof mappedProp === "object") {
        if ( // Typeguard
        mappedProp["type"] !== undefined && mappedProp["props"] !== undefined) {
          var component = mappedProp;
          return _this.renderComponent(component, propKey, index);
        }
      }

      return mappedProp;
    };

    _this.internalMapping = {
      ComponentLookup: _this.ComponentLookup
    };
    return _this;
  }

  ReactFromJSON.getDerivedStateFromProps = function (_, state) {
    return _assign({}, state, {
      counter: {}
    });
  };

  ReactFromJSON.prototype.getNextKey = function (type, propIndex) {
    this.state.counter[type] = this.state.counter[type] || 0;
    var propIndexKey = typeof propIndex !== "undefined" ? "_" + propIndex : "";
    return type + "_" + this.state.counter[type]++ + propIndexKey;
  };

  ReactFromJSON.prototype.renderComponent = function (component, propKey, propIndex) {
    var mapping = this.props.mapping;
    var type = component.type,
        props = component.props;
    var resolvedProps = {};
    var key = this.getNextKey(type, propIndex);
    var childPropKeys = Object.keys(props);

    for (var index = 0; index < childPropKeys.length; index++) {
      var childPropKey = childPropKeys[index];
      var prop = props[childPropKey];
      resolvedProps[childPropKey] = this.resolveProp(prop, childPropKey);
    }

    var MappedComponent = this.internalMapping[type] || mapping[type] || mapping.default;

    if (typeof MappedComponent === "undefined") {
      throw "Tried to render the \"" + type + "\" component, but it's not specified in your mapping.";
    }

    return createElement(MappedComponent, _assign({
      key: key,
      propIndex: propIndex,
      propKey: propKey,
      _type: type
    }, resolvedProps));
  };

  ReactFromJSON.prototype.render = function () {
    var entry = this.props.entry;
    return createElement(Fragment, null, this.resolveProp(entry));
  };

  return ReactFromJSON;
}(Component);

export default ReactFromJSON;